import { FORM_TYPES as types } from './types';
import update from 'immutability-helper';
import { actOptions, policyAction } from '@store/policies/schedule/utils';

export enum formModes {
  new = 'new',
  edit = 'edit',
  delete = 'delete',
}

const initialState = {
  scheduleId: null,
  policies: [],
  activationState: 'now',
  order: [],
  triggerAt: null,
  notes: '',
  emailIds: [],
  loading: false,
  visible: false, // modal
  mode: formModes.new,
  modalType: policyAction.activate,
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_POLICIES] = (state, action) => {
  return update(state, {
    $merge: {
      policies: action.policies,
    },
  });
};

switchMap[types.SET_ORDER] = (state, action) => {
  return update(state, {
    $merge: {
      order: action.order,
    },
  });
};

switchMap[types.SET_ACTIVATION_STATE] = (state, action) => {
  return update(state, {
    $merge: {
      activationState: action.activationState,
    },
  });
};

switchMap[types.SET_TRIGGER_AT] = (state, action) => {
  return update(state, {
    $merge: {
      triggerAt: action.triggerAt,
    },
  });
};

switchMap[types.SET_NOTES] = (state, action) => {
  return update(state, {
    $merge: {
      notes: action.notes,
    },
  });
};

switchMap[types.SET_EMAILS] = (state, action) => {
  return update(state, {
    $merge: {
      emailIds: action.emailIds,
    },
  });
};

switchMap[types.SET_LOADING] = (state, action) => {
  return update(state, {
    $merge: {
      loading: action.loading,
    },
  });
};

switchMap[types.SET_VISIBLE] = (state, action) => {
  return update(state, {
    $merge: {
      visible: action.visible,
    },
  });
};

switchMap[types.RESET] = (state) => {
  return update(state, {
    $set: initialState,
  });
};

switchMap[types.SET_FORM] = (state, action) => {
  return update(state, {
    $merge: {
      ...action.form,
    },
  });
};

switchMap[types.SET_MODAL_TYPE] = (state, action) => {
  return update(state, {
    $merge: {
      modalType: action.modalType,
    },
  });
};

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
